import { Button, Grid } from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import React, { FC, useState } from "react";
import Page from "../../ui/page";
import CrmBoard from "./board";
import CrmCalendar from "./calendar";
import { CrmContextProvider } from "./context";

interface Props {
  location: {
    state?: {
      trade_id?: number;
    };
  };
}

const CRM: FC<Props> = ({ location: { state } }) => {
  const { trade_id } = state || {};
  const [showTrades, setShowTrades] = useState<boolean>(true);

  return (
    <Page
      headerProps={{
        icon: "far fa-handshake",
        title: "Negociação",
        children: (
          <Button
            style={{
              fontWeight: "bolder",
              borderRadius: "100px",
              marginLeft: "10%",
            }}
            variant="contained"
            startIcon={<EventIcon />}
            onClick={() => setShowTrades((oldValue) => !oldValue)}
          >
            {`Mostrar ${showTrades ? "tarefas" : "negociações"}`}
          </Button>
        ),
      }}
    >
      <CrmContextProvider>
        <Grid container>
          {showTrades ? <CrmBoard newTradeId={trade_id} /> : <CrmCalendar />}
        </Grid>
      </CrmContextProvider>
    </Page>
  );
};

export default CRM;
